import classnames from 'classnames';
import React from 'react';

import { inMobileApp } from '@reverbdotcom/commons/src/user_context_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

// Ensures any full page sell form section extends the appropriate viewport height.
export function SellFormPageWrapper({ children }) {
  return (
    <div className={classnames(
      'sell-form-page-wrapper',
      {
        'sell-form-page-wrapper--mobile-native': inMobileApp(useUser()),
      },
    )}>
      {children}
    </div>
  );
}

export default SellFormPageWrapper;
